import {normalizeFileType} from './normalizeFileType';

export const getGenericIconUrl = (fileType?: string, fileName?: string) => {
	return `/icons/${normalizeFileType(fileType, fileName).toLowerCase()}.png`;
};

export default getGenericIconUrl;
